import { PageType } from "shared/lib/page-type";

export const pathname = "/live";

export const page = {
  route(query: QueryParameters) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Live },
    };
  },
};
